import { createAction } from 'typesafe-actions';
import { BodyStatePayload, MainResourceHandler } from './types';

export function createSetBodyStateAction<
  TItemKey,
  TItemSummary extends TItemKey,
  TItemBody extends TItemKey,
>(displayName: string) {
  const setBodyState = createAction(
    `@${displayName}/setBodyState`,
  )<BodyStatePayload>();

  const setBodyStateHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof setBodyState
  > = (state, action) => {
    const { bodyState } = action.payload;
    const { currentRecord } = state;

    if (!currentRecord) {
      console.error(
        'Attempting to set edit state without a current record',
        state,
      );
      return state;
    }

    if (bodyState === currentRecord.bodyState) {
      return state; // no need to update anything
    }

    return {
      ...state,
      currentRecord: { ...currentRecord, bodyState },
    };
  };

  return {
    setBodyState,
    setBodyStateHandler,
  };
}
